const payment = {
  proceedPayment: "Procéder au paiement",
  retryPayment: "Procéder à nouveau au paiement",
  paymentErrorTitle: "Le paiement n'a pas abouti",
  paymentErrorContent:
    "Assurez-vous d'avoir transmis les bonnes informations. Si l'erreur persiste, veuillez contacter l'administrateur.",
  paymentSuccessTitle: "Paiement réussi !",
  paymentSuccessContent:
    "Votre paiement a été validé. Votre abonnement est désormais actif.",
};

export default payment;
